module.exports = __webpack_public_path__ + "media/audio25.5cbf3f02.wav";